const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwayQuickmenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.74 12.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.62px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "away_quickmenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.31,
    y: 3,
    width: 14.12,
    height: 9.55,
    rx: 2.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.31,12.55V1.82A1.37,1.37,0,0,1,4.65.7,1.35,1.35,0,0,1,5.8.33l3,0A1.48,1.48,0,0,1,10,.8a1.36,1.36,0,0,1,.29.78v11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwayQuickmenu);
export default __webpack_public_path__ + "static/media/away_quickmenu.ac2b321f664b4774df0ddcb9abc45a88.svg";
export { ForwardRef as ReactComponent };